<div class="category-container">
    <div class="quick-action-row mobilehide">
        <div>
            <ion-slides #slides [options]="slideMobileOpts">
                <ion-slide *ngFor="let category of categories; let i = index">
                    <ion-button
                        mode="ios"
                        class="catagory-buttons catagory-buttons-mobile"
                        type="button"
                        fill="{{ category.fill }}"
                        size="small"
                        color="light-blue-1"
                        (click)="clickCategory(category, i)"
                        [disabled]="loading?.network"
                        [class.catagory-buttons-mobile-checked]="category.fill === 'outline'"
                    >
                        <span class="catagory-button-inner">
                            <ion-icon [name]="getCategoryIcon(category)" class="catagory-button-icon"></ion-icon>
                            <span class="catagory-button-label">{{ getCategoryDisplayTitle(category) }}</span>
                        </span>
                    </ion-button>
                </ion-slide>
            </ion-slides>
        </div>
    </div>
    <div class="quick-action-row desktophide" text-centered>
        <ion-row class="ion-justify-content-center">
            <ion-button
                *ngFor="let category of categories; let i = index"
                class="catagory-buttons"
                shape="round"
                type="button"
                fill="{{ category.fill }}"
                size="medium"
                [disabled]="(category?.queryObject?.bundles && (showMap$ | async)) || loading?.network"
                color="primary"
                (click)="clickCategory(category, i)"
                (contextmenu)="open($event, category, i)"
            >
                <ion-text>{{ category.title }}</ion-text>
                <!-- [color]="
                    category?.queryObject?.bundles ? 'secondary' : 'primary'
                " -->
                <!-- <ion-icon  *ngIf="category.fill === 'solid'" slot="end" color="light" name="close" size="medium"></ion-icon> -->
            </ion-button>
        </ion-row>
    </div>
    <!-- Template for right click menu -->
    <ng-template #navMenu let-selectedTab>
        <section>
            <ion-item class="context-menu" button (click)="openNewTab(selectedTab)">
                <ion-label>Open in new tab</ion-label>
            </ion-item>
        </section>
    </ng-template>
</div>
